import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { getUserById, updateUser } from "../../../redux/user/action";
import { updateCustomer } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import UploadImage from "../Category/UploadImage";
import { useParams } from "react-router-dom";
import { buildUserUpdatePayload } from "./userUpdateUtils";

const formData = [
  { title: "First Name", name: "first_name" },
  { title: "Last Name", name: "last_name" },
  { title: "Mobile Number", name: "mobile_number" },
  { title: "Email Address", name: "email_id" },
  { title: "Gender", name: "gender" },
  { title: "Status", name: "status" },
  { title: "Account Type", name: "is_testing_account" },
  { title: "Company Name", name: "company_name" },
  { title: "Company Registration Number", name: "company_registration_number" },
  { title: "Company Services", name: "company_services" },
  { title: "Category", name: "category_id" },
  { title: "Company Certificate", name: "company_cr" },
  { title: "Vat Certificate", name: "vat_certificate" },
  { title: "Address", name: "address" },
];

const Addadmin = ({ data }) => {
  const { id } = useParams();
  const [gender, setGender] = useState(1);
  const [profileimage, setProfileimage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(data?.update);
  const dispatch = useDispatch();
  const selectedUser = useSelector(({ user: { userbyid } }) => userbyid);

  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
      setUpdate(true);
    }
  }, [id]);

  const initialValues = {
    ...formData.reduce((acc, field) => {
      acc[field.name] = selectedUser?.[field.name] || "";
      return acc;
    }, {}),
    mobile_number: selectedUser?.mobile_number || "",
    country_code: selectedUser?.country_code || "",
    is_testing_account: selectedUser?.is_testing_account ? "1" : "0",
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: (value) => handelSubmit(value),
    validationSchema: updateCustomer(),
  });

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  const handelSubmit = async (values) => {
    if (Object.keys(formik.errors).length > 0) {
      return;
    }
    setLoading(true);

    try {
      const { password, ...restValues } = values;
      const data = buildUserUpdatePayload(restValues, id);
      if (password) {
        data.password = password;
      }

      dispatch(updateUser(data, setLoading, navigate));
      setUpdate(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };
  const navigate = useNavigate();

  return (
    <Card className="p-3 category-wrapper">
      <h3 className="pb-3">Update User</h3>
      <CardBody className="">
        <form onSubmit={formik.handleSubmit}>
          <Row className=" ">
            {formData.map((prop, key) => {
              if (prop.title === "Mobile Number") {
                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label htmlFor={prop.name}>{(prop.title)}</label>
                      <PhoneInput
                        country={"in"}
                        value={
                          formik.values.mobile_number
                            ? `${formik.values.country_code}${formik.values.mobile_number}`
                            : ""
                        }
                        onChange={(phone, data) =>
                          handleCountryCode(phone, data)
                        }
                        onBlur={() => formik.setFieldTouched(prop.name, true)}
                      />
                    </div>
                    {(formik.touched.mobile_number ||
                      formik.errors.mobile_number) && (
                      <p style={{ color: "red" }}>
                        {formik.errors.mobile_number}
                      </p>
                    )}
                  </Col>
                );
              }
              if (prop.name === "status") {
                const options = [
                  { value: "1", label: ("Active") },
                  { value: "2", label: ("Inactive") },
                  { value: "3", label: ("Block") },
                ];

                return (
                  <Col className="  form-group" key={key} xs={4}>
                    <label>{(prop.title)}</label>selectedStatus
                    <div>
                      <ReactSelect
                        value={options.filter(
                          (option) => option.value === formik.values?.status
                        )}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        options={options}
                        onChange={(selectedOption) =>
                          formik.handleChange(prop.name)(selectedOption.value)
                        }
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched[prop.name] &&
                        formik.errors[prop.name] && (
                          <div className="error">
                            {(formik.errors[prop.name])}
                          </div>
                        )}
                    </div>
                  </Col>
                );
              }

              if (prop.name === "is_testing_account") {
                const options = [
                  { value: "0", label: "Customer" },
                  { value: "1", label: "Testing Account" },
                ];

                return (
                  <Col className="form-group" key={key} xs={4}>
                    <label>{prop.title}</label>
                    <div>
                      <ReactSelect
                        value={options.find(
                          (option) =>
                            option.value ===
                            String(formik.values?.is_testing_account ?? "0")
                        )}
                        placeholder={prop.title}
                        id={prop.name}
                        name={prop.name}
                        options={options}
                        onChange={(selectedOption) =>
                          formik.setFieldValue(
                            "is_testing_account",
                            selectedOption?.value || "0"
                          )
                        }
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </Col>
                );
              }

              if (prop.name === "password") {
                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label>Password</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />
                    </div>
                  </Col>
                );
              }

              if (prop.name === "profile_image") {
                return (
                  <UploadImage
                    files={profileimage}
                    setFiles={setProfileimage}
                    update={update}
                    prop={prop}
                    formik={formik}
                  />
                );
              }
              if (prop.name === "gender") {
                const options = [
                  { value: 1, label: ("Male") },
                  { value: 2, label: ("Female") },
                ];

                return (
                  <Col key={key} xs={4}>
                    <label>{(prop.title)}</label>
                    <div>
                      <ReactSelect
                        value={options.find(
                          (option) => option.value === formik.values?.[prop.name]
                        )}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        options={options}
                        onChange={(option) => {
                          formik.setFieldValue("gender", option?.value);
                          setGender(option?.value);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched[prop.name] &&
                        formik.errors[prop.name] && (
                          <div className="error">
                            {(formik.errors[prop.name])}
                          </div>
                        )}
                    </div>
                  </Col>
                );
              }
              if (prop.name === "dob") {
                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label>{prop?.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                        type="date"
                      />
                    </div>
                  </Col>
                );
              }
              if (prop.name === "email_id") {
                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label>{prop?.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />
                    </div>
                    {formik.values.email_id &&
                      formik.touched.email_id &&
                      formik.errors.email_id && (
                        <p style={{ color: "red" }}>{formik.errors.email_id}</p>
                      )}
                  </Col>
                );
              }
              return (
                <Col className="  " key={key} xs={4}>
                  <div className="form-group">
                    <label>{prop?.title}</label>
                    <CustomInput
                      value={formik.values?.[prop.name]}
                      placeholder={(prop.title)}
                      id={prop.name}
                      name={prop.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      touched={formik.touched}
                      errors={formik.errors}
                    />
                  </div>
                </Col>
              );
            })}
            <Col
              md={12}
              className="text-center my-3 d-flex align-items-center justify-content-between"
              style={{ padding: "15px" }}
            >
              <button
                className="background-button w-25pb-3"
                disabled={loading}
                type="submit"
              >
                <span style={{ fontSize: "16px" }}>
                  {!loading ? (
                    data?.update && selectedUser?.id ? (
                      ("Update")
                    ) : (
                      ("Submit")
                    )
                  ) : (
                    <Spinner />
                  )}
                </span>
              </button>
            </Col>
          </Row>
        </form>
      </CardBody>
    </Card>
  );
};

export default Addadmin;
